/** @jsx jsx */
import { jsx } from "theme-ui"
import Heading from "../components/heading";
import Layout from "../components/layout";
import Canada from '../images/partners/canada.png'
import Stjohns from '../images/partners/stjohns.png'
import Healthy from '../images/partners/healthy.png'
import Nfl from '../images/partners/nfl.png'
import Text from "../components/text";

function PartnersPage() {
    return (
        <Layout title="Partners">
            <div style={{maxWidth: '900px', margin: '0 auto', marginTop: '40px', textAlign: 'center',}}>
                <Heading mbLarge>Thank you to our partners!</Heading>

                <div sx={{width: '100%', mb: 6,}}>
                    <div sx={{display: 'flex', mb: 5, justifyContent: 'space-around', alignItems: 'center',}}>
                        <img src={Canada} width={200} height={52} />
                        <img src={Healthy} width={200} height={44} />
                    </div>
                    <div sx={{display: 'flex', justifyContent: 'space-around', alignItems: 'center',}}>
                        <img src={Nfl} width={200} height={100} />
                        <img src={Stjohns} width={200} height={31} />
                    </div>
                </div>

                <div style={{marginBottom: '40px'}}>
                    <Text bold>Credits:</Text>
                    <ul>
                        <li><Text>Po Chun Lau, curator (first 100 works)</Text></li>
                        <li><Text>Hazel Eckert, graphic designer</Text></li>
                        <li><Text>Kevin Doole, app creator</Text></li>
                    </ul>
                </div>
            </div>
        </Layout>
    )
}

export default PartnersPage